<template>
  <div>
    <el-dialog ref='dialog' title="条件配置">
      <div class='fz-12 m-t-10'>
        <span>*日期时间变量说明：Y代表年，M代表月，D代表天，H代表时，I代表分，S代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。
          例：D+1代表明天，M+1代表下个月，H+1代表一个小时后， m+10代表十分钟后，s+30代表30秒后，不填即为当前时间。同时支持格式化时间变量格式：(Y+1)-(M)-19 00:(I+5):S</span><br/>
          <span>*同一个字段可能有多种情况，且如果是时间变量的话，有可能存在两个条件同时成立的情况，那么就按位置在前面的来显示</span>
      </div>
      <div class="m-t-10">
        <el-table
        :data="form"
        border
        style="width: 100%">
          <el-table-column
            label="字段"
            width="160">
            <template scope="scope">
              <el-select v-model="scope.row.field_id" size="small">
                <el-option 
                  v-for="item in fields"
                  :label="item.title"
                  :value="item.field_id">
                  <span>{{ item.field }}（{{ item.title }}）</span>
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="逻辑"
            width="160">
            <template scope="scope">
              <el-select v-model="scope.row.logic" size="small">
                <el-option v-for="option in logicOptions" :label="option.label" :value="option.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="值类型"
            width="160">
            <template scope="scope">
              <el-select v-model="scope.row.type" size="small">
                <el-option v-for="option in typeOptions" :label="option.label" :value="option.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="值">
            <template scope="scope">
              <el-input v-model='scope.row.value'></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100">
            <template scope="scope">
              <el-button type="text" size="small" @click="deleteConfig(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="m-t-10 block">
          <el-button type="info" @click="addConfig()">添加</el-button>
        </div>
      </div>
      <div class="footer">
        <el-button @click="closeDialog()">取消</el-button>
        <el-button type="primary" @click="sure()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
  .el-dialog--small {
    width: 60%;
  }
  .footer {
    text-align: right;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
  }
  .selectMapName .el-form-item__content {
    float: left;
  }
</style>
  
<script>
export default {
  props: {
    fields: {
      type: Array,
      default() {
        return []
      }
    },
    curConfig: {
      type: Array,
      default() {
        return []
      }
    },
    index: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      form: [],
      logicOptions: [
        { label: '<', value: '<' },
        { label: '<=', value: '<=' },
        { label: '=', value: '=' },
        { label: '!=', value: '!=' },
        { label: '>=', value: '>=' },
        { label: '>', value: '>' }
      ],
      typeOptions: [
        { label: '常量', value: '10' },
        { label: '日期时间变量', value: '20' }
      ]
    }
  },
  created() {
  },
  methods: {
    open() {
      this.$refs.dialog.open()
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    deleteConfig(index) {
      this.form.splice(index, 1)
    },
    addConfig() {
      this.form.push({
        field_id: '',
        logic: '',
        type: '',
        value: ''
      })
    },
    sure() {
      this.$emit('setCurConfig', this.index, this.form)
      this.closeDialog()
    }
  },
  watch: {
    'curConfig'() {
      this.form = this.curConfig
    }
  },
  mixins: []
}
</script>



// WEBPACK FOOTER //
// sheetConfig.vue?090daee9